/* Vivasio Sticky-Kaufleiste (PDP)
   - sichtbar, sobald der Original-Kaufbutton oben aus dem Viewport gescrollt ist
   - unsichtbar beim Footer, bei offenem Drawer und solange der Button im Bild ist
   - Preis, Variante, Bild und Button-Zustand folgen dem Impulse-Event "variantChange"
   - Klick reicht an das Hauptformular weiter (theme.AjaxProduct uebernimmt den Rest) */
(function () {
  'use strict';

  var bar = document.querySelector('[data-vsc]');
  if (!bar) return;

  var form = document.getElementById(bar.dataset.formId);
  var section = document.querySelector('[data-section-id="' + bar.dataset.sectionId + '"][data-section-type="product"]');
  if (!form || !section) return;

  var mainBtn = form.querySelector('[data-add-to-cart]');
  var footer = document.querySelector('.site-footer');
  /* Sprungziel: erste sichtbare Variantenauswahl, sonst das Formular selbst */
  function jumpTarget() {
    var candidates = section.querySelectorAll('.variant-wrapper, [data-variant-input], .product-block--price');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].offsetParent !== null) return candidates[i].closest('.product-block') || candidates[i];
    }
    return form;
  }

  var el = {
    button: bar.querySelector('[data-vsc-button]'),
    buttonText: bar.querySelector('[data-vsc-button-text]'),
    price: bar.querySelector('[data-vsc-price]'),
    compare: bar.querySelector('[data-vsc-compare]'),
    variant: bar.querySelector('[data-vsc-variant]'),
    image: bar.querySelector('[data-vsc-image]'),
    jump: bar.querySelector('[data-vsc-jump]')
  };

  if (!mainBtn || !el.button) return;
  bar.setAttribute('data-vsc-ready', '');

  /* Steuert eine App die Varianten (Theme-Auswahl ausgeblendet), erreicht uns
     kein variantChange. Dann lieber kein Variantenlabel als ein falsches. */
  var themePicker = section.querySelector('.variant-wrapper');
  if (el.variant && (!themePicker || themePicker.offsetParent === null)) {
    el.variant.textContent = '';
  }

  var state = { buttonPassed: false, footerVisible: false, drawerOpen: false };

  function render() {
    var visible = state.buttonPassed && !state.footerVisible && !state.drawerOpen;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
  }

  /* Sichtbarkeit: Button oben raus -> Leiste rein. Button noch unterhalb
     (nicht erreicht) -> keine Leiste, sonst deckt sie beim Laden Inhalt ab.
     Bewusst kein IntersectionObserver: Der meldet sich nur beim Betreten oder
     Verlassen des Sichtbereichs. Springt die Seite in einem Schritt ueber den
     Button hinweg (Sprungmarke, Zurueck-Navigation, schneller Wisch), bleibt
     er stumm. Eine Rechteckabfrage pro Scroll-Frame ist fuer zwei Elemente
     vernachlaessigbar und in jeder Lage korrekt. */
  var ticking = false;
  function measure() {
    ticking = false;
    state.buttonPassed = mainBtn.getBoundingClientRect().bottom < 0;
    if (footer) {
      var f = footer.getBoundingClientRect();
      state.footerVisible = f.top < window.innerHeight && f.bottom > 0;
    }
    render();
  }
  function requestMeasure() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(measure); }
  }
  window.addEventListener('scroll', requestMeasure, { passive: true });
  window.addEventListener('resize', requestMeasure, { passive: true });
  window.addEventListener('pageshow', requestMeasure);
  measure();

  /* Offener Drawer (Warenkorb, Menue): Impulse setzt js-drawer-open auf <html> */
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      var open = document.documentElement.classList.contains('js-drawer-open');
      if (open !== state.drawerOpen) { state.drawerOpen = open; render(); }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  function money(cents) {
    return (window.theme && theme.Currency)
      ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
      : (cents / 100).toFixed(2);
  }

  /* Quadratischen Zuschnitt ueber die CDN-Parameter bauen. Bewusst nicht
     theme.Images.getSizedImageUrl: Dessen Muster kennt kein .webp und liefert
     fuer solche Bilder null, wodurch das Vorschaubild stehen bliebe. */
  function sized(src, px) {
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', px);
      u.searchParams.set('height', px);
      u.searchParams.set('crop', 'center');
      return u.href;
    } catch (e) {
      return src;
    }
  }

  var BILD_GROESSEN = [160, 240, 320, 448];

  function bildSetzen(src) {
    el.image.src = sized(src, 240);
    el.image.srcset = BILD_GROESSEN.map(function (px) { return sized(src, px) + ' ' + px + 'w'; }).join(', ');
    el.image.sizes = '(max-width: 768px) 88px, 112px';
  }

  /* Bundle-Widget (Pumper Bundles) im Kaufbereich: Es waehlt Tarife ueber
     Radios name="cb" und schreibt den Tarifpreis in .prvw_totalAmount_price_*.
     Ist ein Tarif gewaehlt, zeigt die Leiste diesen Preis, weil genau er in den
     Warenkorb geht. Fehlt die Struktur (App entfernt oder geaendert), bleibt
     der Theme-Preis stehen. Nichts hier kann den Kauf selbst beeinflussen. */
  function widgetPrice() {
    var checked = section.querySelector('input[type="radio"][name="cb"]:checked');
    if (!checked) return null;
    var tier = checked.closest('.block__cb');
    if (!tier) return null;
    var priceEl = tier.querySelector('[class*="prvw_totalAmount_price"]');
    if (!priceEl || !/\d/.test(priceEl.textContent)) return null;
    var compareEl = tier.querySelector('[class*="originalAmount"]');
    var compare = compareEl && /\d/.test(compareEl.textContent) ? compareEl.textContent.trim() : '';
    return { price: priceEl.textContent.trim(), compare: compare };
  }

  function applyWidgetPrice() {
    var w = widgetPrice();
    if (!w) return false;
    el.price.textContent = w.price;
    el.compare.textContent = w.compare;
    el.compare.classList.toggle('hide', !w.compare);
    return true;
  }

  section.addEventListener('change', function (evt) {
    if (evt.target && evt.target.name === 'cb') applyWidgetPrice();
  });
  /* Das Widget rendert asynchron nach dem Theme-Skript: mehrfach nachfassen */
  applyWidgetPrice();
  [600, 1800, 4000].forEach(function (ms) { setTimeout(applyWidgetPrice, ms); });

  /* Variante gewechselt: Werte aus dem Impulse-Event uebernehmen */
  section.addEventListener('variantChange', function (evt) {
    var variant = evt.detail && evt.detail.variant;

    if (!variant) {
      el.button.disabled = true;
      el.button.classList.add('disabled');
      el.buttonText.textContent = theme.strings.unavailable;
      return;
    }

    el.price.innerHTML = money(variant.price);
    if (variant.compare_at_price > variant.price) {
      el.compare.innerHTML = money(variant.compare_at_price);
      el.compare.classList.remove('hide');
    } else {
      el.compare.innerHTML = '';
      el.compare.classList.add('hide');
    }

    applyWidgetPrice();

    if (el.variant && themePicker && themePicker.offsetParent !== null) el.variant.textContent = variant.title || '';

    if (el.image && variant.featured_image && variant.featured_image.src) {
      bildSetzen(variant.featured_image.src);
    }

    if (variant.available) {
      el.button.disabled = false;
      el.button.classList.remove('disabled');
      el.buttonText.textContent = el.buttonText.dataset.defaultText;
    } else {
      el.button.disabled = true;
      el.button.classList.add('disabled');
      el.buttonText.textContent = theme.strings.soldOut;
    }
  });

  /* Kauf: Hauptformular abschicken, Ladezustand spiegeln */
  var loadingTimer = null;
  function stopLoading() {
    el.button.classList.remove('btn--loading');
    el.button.style.width = '';
    if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
  }

  el.button.addEventListener('click', function () {
    if (mainBtn.disabled || el.button.disabled) return;
    /* Das Theme blendet den Buttontext im Ladezustand per text-indent aus. Der
       Haupt-Button hat feste Breite und bleibt stehen; dieser richtet sich nach
       dem Text und faellt sonst auf die Polsterung zusammen - der 24 px grosse
       Ladekreis quillt dann heraus. Breite vorher festhalten, danach freigeben. */
    el.button.style.width = el.button.getBoundingClientRect().width + 'px';
    el.button.classList.add('btn--loading');
    loadingTimer = setTimeout(stopLoading, 8000);
    /* Echter Klick statt requestSubmit: Bundle- und Upsell-Apps haengen sich an
       den Klick des Original-Buttons. So passiert exakt dasselbe wie dort. */
    mainBtn.click();
  });

  document.addEventListener('ajaxProduct:added', stopLoading);
  form.addEventListener('ajaxProduct:added', stopLoading);
  form.addEventListener('ajaxProduct:error', stopLoading);

  /* Klick auf Bild oder Text: zur Variantenauswahl bzw. zum Formular springen */
  if (el.jump) {
    el.jump.addEventListener('click', function () {
      var header = document.querySelector('.header-sticky-wrapper');
      var offset = header ? header.getBoundingClientRect().height + 24 : 24;
      var picker = jumpTarget();
      var top = picker.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      var firstInput = picker.querySelector('select, input');
      if (firstInput) setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 400);
    });
  }
})();
